import './shop.less';
import Filters from './filters';

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';

import _isEmpty from 'lodash/fp/isEmpty';
import _propOr from 'lodash/fp/propOr';
import ModalPopup from './../modal-popup/main';
import debounce from 'lodash/debounce';
import { Link } from 'react-router';

import dandruffIcon from '../../../../assets/img/market/dandruff.svg';

const getTranslation = (field, lang, good) => {
	return _propOr(good[field], ['translations', lang, field])(good);
};

class Item extends React.Component  {
	render() {
		const { intl, good, user, currentLang, initPopup, saveUpForGood, index, toggleCategoryItem } = this.props;
		const orderButton = {
			text: 'Want save-up for',
			action: () => saveUpForGood(good.id),
			isNotActiveOrder: false
		};

		if (user.preferred_gift === good.id) {
			orderButton.text = 'Stop save-up for';
			orderButton.action = () => saveUpForGood(null);
			orderButton.isNotActiveOrder = true;
		}
		if (user.contest_points >= good.price) {
			orderButton.text = 'Order';
			orderButton.action = () => initPopup( good, user, currentLang);
			orderButton.isNotActiveOrder = false;
		}
		if (_isEmpty(user)) {
			orderButton.text = 'Want save-up for';
			orderButton.action = () => {window.location.href = '//rocketprofit.com'; };
			orderButton.isNotActiveOrder = false;
		}
		return (
			<Link className={cn({
				'shop__item': true,
				'shop__item-save': orderButton.isNotActiveOrder && user.contest_points < good.price,
				'shop__item-need__more': user.contest_points < good.price,
				'shop__item_non-active': _isEmpty(user)
			})}
			id={`#good_${index}`}
			to={`market/${good.id}`}
			>
				<div className="shop__item-img">
					<img src={good.image} alt="" className="shop__item-pic"/>
				</div>
				<div
					className="shop__item-category"
					onClick={(e) => {
						e.preventDefault();
						toggleCategoryItem(good.category.id);
					}}
				>
					{intl(good.category[`name_${intl.language}`])}
				</div>
				<h4 className="shop__item-title">{getTranslation('title', currentLang, good)}</h4>
				<p className="shop__item-desc">{getTranslation('description', currentLang, good)}</p>
				<div className="shop__item-bottom">
					<div className="shop__item-points">
						<div className="shop__item-points-number">{good.price}</div>
						<div className="shop__item-points-curr">{intl('points')}</div>
					</div>
					<button
						className={cn({
							'btn': true,
							'btn_order': user.contest_points < good.price,
							'btn_hover': true,
							'btn_non-active': orderButton.isNotActiveOrder && user.contest_points < good.price
						})}
						onClick={e => {e.preventDefault();orderButton.action();} }
					>{ intl(orderButton.text) }</button>
				</div>
				{!_isEmpty(user) && (
					<div className="shop__item-message">
						{intl('Not enough points, need to')}
						<span className="shop__item-message-points"> {good.price - Math.floor(user.contest_points)} </span>
						{intl('more')}
					</div>
				)}
			</Link>
		);
	}
}

Item.propTypes = {
	intl: PropTypes.func,
	submitFromPopup: PropTypes.func,
	index: PropTypes.number,
	toggleCategoryItem: PropTypes.func,
	initPopup: PropTypes.func,
	saveUpForGood: PropTypes.func,
	good: PropTypes.object,
	user: PropTypes.object,
	currentLang: PropTypes.string,
	handleOrder: PropTypes.func
};

const Main = (props) => {
	const { intl, user, goods, goodsTotal, searchGoods, toggleCategoryItem, query, isOrderButtonDisabled,
		toggleOnlyAvailable, toggleOrderItem, currentLang, handleOrder, goodCardNumber,
		categories, popupInfo, hidePopup, initPopup, paginateGoods, saveUpForGood } = props;
	return (
		<div className='shop'>
			<div className='controls'>
				<Filters
					user={user}
					intl={intl}
					categories={categories}
					toggleCategoryItem={toggleCategoryItem}
					toggleOnlyAvailable={toggleOnlyAvailable}
					toggleOrderItem={toggleOrderItem}
					query={query}
				/>
				<div className="controls__search">
					<input
						onChange={e => {
							const value = e.target.value;
							return debounce(() => searchGoods(value), 300)();
						}}
						type="search"
						className="controls__search-input"
						placeholder={intl('Search gift')}/>
					<div className="controls__search-icon">
						<img src={dandruffIcon} alt="" className="controls__search-img"/>
					</div>
				</div>
			</div>
			<div className={cn({'goods-list__container': true, 'hidden': !!goodCardNumber})}>
				<ul className='shop__list'>
					{goods && goods.map(good => (
						<Item
							key={good.id}
							index={good.id}
							intl={intl}
							good={good}
							currentLang={currentLang}
							initPopup={initPopup}
							toggleCategoryItem={toggleCategoryItem}
							saveUpForGood={saveUpForGood}
							user={user}
						/>))}
					<ModalPopup
						isOrderButtonDisabled={isOrderButtonDisabled}
						intl={intl}
						popupInfo={popupInfo}
						handleOrder={handleOrder}
						hidePopup={hidePopup}
					/>
				</ul>
				{goods && goods.length < parseInt(goodsTotal) && (
					<div className="show-more">
						<button className="btn btn_show-more" onClick={paginateGoods}>
							{intl('Show more')}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

Main.propTypes = {
	intl: PropTypes.func,
	paginateGoods: PropTypes.func,
	goodCardNumber: PropTypes.number,
	toggleCategoryItem: PropTypes.func,
	toggleOnlyAvailable: PropTypes.func,
	saveUpForGood: PropTypes.func,
	toggleOrderItem: PropTypes.func,
	searchGoods: PropTypes.func,
	user: PropTypes.object,
	query: PropTypes.object,
	goods: PropTypes.array,
	currentLang: PropTypes.string,
	goodsTotal: PropTypes.string,
	popupInfo: PropTypes.object,
	handleOrder: PropTypes.func,
	initPopup: PropTypes.func,
	hidePopup: PropTypes.func
};

export default Main;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/store/shop.js